import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditPartnerExtension
 */
@Entity()
export class BaseKPFEditPartnerExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditPartnerExtension';
}
